import React, { useState, useEffect } from 'react';
import {
  DownOutlined,
  LeftOutlined,
  RightOutlined,
  BellFilled,
} from '@ant-design/icons';
import { Avatar, Layout, Menu, Badge } from 'antd';
import SubMenu from 'antd/lib/menu/SubMenu';
import Logo from '../../../assets/logo.png';
import { ReactComponent as LogoutIcon } from '../../../assets/logout.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import useProfile from './useSidebar';
import { ReactComponent as DotIcon } from '../../../assets/dot.svg';
import { ReactComponent as UserIcon } from '../../../assets/user-icon.svg';
// import collapsedIcon from '../../../assets/collapsed-logo.png';
import UseWindowSize from './useWindowSize';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser, setNavbarCollapsed } from '../../login/redux/actions';
// import NotificationChannel from '../notifications/notificationChannel';
import Notifications from '../notifications/index';
// import { fetchUnreadNotifications } from '../notifications/notificationsRedux/notificationActions';

const SidebarComponent = (props) => {
  const { Sider } = Layout;
  const [shouldCollapse, setShouldCollapse] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logoutLoading } = useSelector((state) => state?.authReducer);
  const { unreadNotifications } = useSelector(
    (state) => state.notificationsReducer
  );

  const dispatch = useDispatch();
  const [menuItemsData] = useProfile();
  const [SelectProjectsModalvisible, setSelectProjectsModalVisible] =
    useState(false);
  const [notificationModalvisible, setNotificationModalVisible] =
    useState(false);
  const [selectedProjects, setSelectedProjects] = useState([]);

  const screenWidth = UseWindowSize();

  useEffect(() => {
    if (screenWidth < 992) {
      setShouldCollapse(false);
      setCollapsed(true);
      dispatch(setNavbarCollapsed(true));
    } else {
      setShouldCollapse(true);
    }
  }, [screenWidth]);

  useEffect(() => {
    // dispatch(fetchUnreadNotifications());
    // dispatch(
    //   fetchAllUserProjects({ search: {}, sortedInfo: null, user_id: user.id })
    // );
  }, [location.pathname]);

  const isSelected = (id, eventKey) => {
    let isProjectControl = location.pathname.includes(`npo/${eventKey}`);
    if (isProjectControl) {
      let urlID = location.pathname.split('/').slice(-1)[0];
      return urlID == id ? true : false;
    } else {
      return false;
    }
  };

  const handleSelectedKey = () => {
    if (location.pathname.includes('/users-manager')) {
      return '/users-manager';
    }

    if (location.pathname.includes('/institute-management')) {
      return '/institute-management';
    }

    if (location.pathname === '/') {
      let path = '/profile';
      navigate(path);
      return path;
    }

    return location.pathname;
  };

  const handleLogout = () => {
    dispatch(logoutUser({ navigate, id: user.id }));
  };

  const menuSubItems = (item) => {
    const { name, link, hasSubItems } = item;
    if (name === 'divider') {
      return '';
      // return <Divider className='sidebar-settings-divider' />;
    }

    if (hasSubItems) {
      const { name, key, subItems } = item;
      return (
        <SubMenu
          key={key}
          icon={
            <DotIcon
              fill='#ffffff'
              className='dot-icon'
              style={{
                margin: collapsed ? '0px 2px 0px 3px' : '0px 10px 0px 10px',
              }}
            />
          }
          title={
            <span className={`${key} ${'settings-title-span'}`}>{name}</span>
          }
        >
          {subItems?.map((el) => {
            const { hasPermission } = el;

            return hasPermission && menuSubItems(el);
          })}
        </SubMenu>
      );
    }

    let isFormSubitem = link.includes('form-manager');
    const { pathname } = location;
    let clsName = pathname.includes(item.link) && 'selected';

    return (
      <Menu.Item
        onClick={() => navigate(link)}
        className={`subitems-custom ${
          isFormSubitem && !collapsed && 'form-subitem'
        } ${clsName}`}
        key={link}
        style={{
          padding: collapsed ? `0px !important` : '10px 15px 10px 45px',
          paddingLeft: collapsed ? '10px' : '45px',
        }}
        icon={
          !isFormSubitem && (
            <DotIcon
              fill='#ffffff'
              className='dot-icon'
              style={{
                margin: collapsed ? '0px' : '0px 5px 0px 0px',
              }}
            />
          )
        }
      >
        {isFormSubitem && `- `} {name}
      </Menu.Item>
    );
  };

  return (
    <>
      {/* <NotificationChannel /> */}
      <Notifications
        visible={notificationModalvisible}
        setVisible={setNotificationModalVisible}
      />
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={collapsed ? '70px' : `260px`}
        className={`main-sidebar${collapsed ? `-collapsed` : ''} `}
      >
        {shouldCollapse && (
          <span
            onClick={() => {
              setCollapsed(!collapsed);
              dispatch(setNavbarCollapsed(!collapsed));
            }}
            className='sidebar-pin-icon'
          >
            {collapsed ? <RightOutlined /> : <LeftOutlined />}
          </span>
        )}
        <div
          className='trigger sidebar-child-div'
          // onClick={() => shouldCollapse && setCollapsed(!collapsed)}
        >
          {collapsed ? (
            <div
              className='nav-collapsed-img-div'
              style={{
                margin: collapsed ? '15px 0' : '0px 10px',
              }}
              onClick={() => navigate('/')}
            >
              <img src={Logo} alt='' />
            </div>
          ) : (
            <div className='nav-uncollapsed-img-div'>
              <img
                src={Logo}
                alt='Logo'
                style={{
                  margin: collapsed && '0px !important',
                }}
                onClick={() => navigate('/')}
              />
            </div>
          )}
        </div>
        <Menu
          theme='light'
          mode='inline'
          className='sidebar-custom'
          defaultSelectedKeys={[location.pathname]}
          selectedKeys={[handleSelectedKey()]}
        >
          {menuItemsData.map((el) => {
            const {
              key,
              src,
              SvgImg,
              name,
              link,
              hasSubItems,
              subItems,
              hasPermission,
            } = el;
            // console.log('el', el);
            let topBorder = 'menu-item-for-top-border';
            return hasSubItems && hasPermission ? (
              <SubMenu
                className={`${topBorder} ${collapsed ? '-collapsed' : ''}`}
                key={key}
                icon={
                  <SvgImg
                    className='project-icon'
                    style={{
                      margin: collapsed ? '0px' : '0px 5px 0px 0px',
                    }}
                  />
                }
                title={
                  !collapsed && (
                    <span
                      className={` ${
                        key === 'project-control' ? '' : 'settings-title-span'
                      }`}
                    >
                      {name}
                    </span>
                  )
                }
              >
                {subItems?.map((el) => {
                  const { hasPermission, key } = el;

                  return hasPermission && menuSubItems(el);
                })}
              </SubMenu>
            ) : name === 'notification' ? (
              !shouldCollapse && (
                <Menu.Item
                  className='sidebar-notification-menu-item'
                  onClick={(e) => {
                    //   dispatch(fetchNotificationsList());
                    setNotificationModalVisible(!notificationModalvisible);
                  }}
                  key={'/notification'}
                  icon={
                    <Badge count={unreadNotifications} overflowCount={9}>
                      <BellFilled />
                    </Badge>
                  }
                ></Menu.Item>
              )
            ) : (
              el?.hasPermission && (
                <Menu.Item
                  onClick={() => navigate(link)}
                  key={link}
                  className={
                    link === '/profile'
                      ? `sidebar-custom-menuitem menu-item-for-top-border${
                          collapsed ? '-collapsed' : ''
                        }`
                      : `${collapsed ? '-collapsed' : ''}`
                  }
                  icon={
                    link === '/profile' ? (
                      <div className='sidebar-profile-icon'>
                        <Avatar
                          shape={'circle'}
                          style={{
                            margin: collapsed ? '0px' : '0px 5px 0px 0px',
                          }}
                          src={src ? src : <UserIcon />}
                        />
                      </div>
                    ) : (
                      <Avatar
                        className='profile-avatar'
                        shape={'square'}
                        style={{
                          margin: collapsed ? '0px' : '0px 5px 0px 0px',
                        }}
                        src={
                          SvgImg ? <SvgImg className='profile-svg-icon' /> : src
                        }
                      />
                    )
                  }
                >
                  {link === '/profile' ? (
                    <div className='profile-menu-div'>
                      <div className='profile-username-div'>
                        <p>{name}</p>
                        <span>{el.role}</span>
                      </div>
                      {!collapsed && (
                        <div
                          style={{
                            paddingRight: 12,
                            zIndex: 999999999999999,
                          }}
                          // onClick={(e) => {
                          //   e.stopPropagation();
                          //   // dispatch(fetchNotificationsList());
                          //   setNotificationModalVisible((e) => !e);
                          // }}
                        >
                          {/* <Badge count={unreadNotifications} overflowCount={9}>
                            <BellFilled className='notification-icon' />
                          </Badge> */}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className='profile-menu-div'>{name}</div>
                  )}
                </Menu.Item>
              )
            );
          })}
          <Menu.Item
            className={`sidebar-custom-menuitem ${
              collapsed ? '-collapsed' : ''
            }`}
            style={{
              cursor: 'default',
            }}
            key={'none'}
          ></Menu.Item>
          <Menu.Item
            onClick={() => !logoutLoading && handleLogout()}
            className={`sidebar-custom-menuitem menu-item-for-top-border${
              collapsed ? '-collapsed' : ''
            } logout-menu-item`}
            key={'logout'}
            icon={<LogoutIcon />}
          >
            Logout {logoutLoading && '...'}
          </Menu.Item>
        </Menu>
      </Sider>
    </>
  );
};
export default SidebarComponent;
